module.exports = __webpack_public_path__ + "img/Meta_Platforms_Inc._logo.3fa94cb1.svg";